import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import {
  LicenseTypes,
  Operation,
  PageFor,
} from "../../../../../utils/Enum.types";
import Add from "./Add";
import List from "./List";
import { IObjectKeys } from "../../../../../utils/formTypes";
import { Form, Formik, FormikProps } from "formik";
import { categoryValidation } from "../../../../../utils/validationSchema";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import useUrlParams from "../../../../../customHooks/useUrlParams";

import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { nodeVar, OrderDirection } from "../../../../../utils/commonQueryTypes";
import { AppContext } from "../../../../../context/context";
import MessageModal from "../../../../../customComponents/MessageModal";
import {
  GetManufacturerByNodeId,
  GetStockManufacturers,
} from "./queries/queries";
import {
  AddStockManufacturerResult,
  AddStockManufacturerVar,
  AtsStckManufacturer,
  AtsStckManufacturerOrderField,
  UpdateStockManufacturerResult,
  UpdateStockManufacturerVar,
} from "./queries/types";
import {
  AddStockManufacturer,
  UpdateStockManufacturer,
} from "./queries/mutations";
import { msgType } from "../../../../../utils/types";
import Close from "../../../../../images/Close.svg";
import { MasterDataProps } from "../itemgroup/Index";
import LoadingModal from "../../../../pages/LoadingModal";
import { payloadTypes } from "../../../../../context/reducer";
import Navbar from "../../../../common/layout/Navbar";

interface formDataType extends IObjectKeys {
  groupName: string;
}

export interface CommonProps extends MasterDataProps {
  setOperation: React.Dispatch<React.SetStateAction<Operation>>;
}
export interface AddMasterDataProps extends CommonProps {
  formData: formDataType;
  handleValueChange: (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<formDataType>
  ) => void;
  meta: FormikProps<formDataType>;
  operation: Operation;
}

export interface ListPageProps extends CommonProps {
  setMessage: React.Dispatch<React.SetStateAction<msgType>>;
}

const Manufacturer = ({ type, setModal }: MasterDataProps) => {
  const navigate = useNavigate();
  const [message, setMessage] = useState(emptyMessage);


  const { user_details } = useLoggedInUserDetails();

  const { state, dispatch } = useContext(AppContext);

  const [operation, setOperation] = useState(Operation.CREATE);
  const { customer_id } = useUrlParams();
  const [formData, setFormData] = useState<formDataType>({
    groupName: "",
  });

  const [GetManufacturer, { loading: GetManufacturerByNodeIdLoading }] =
    useLazyQuery<{ node: AtsStckManufacturer }, nodeVar>(
      GetManufacturerByNodeId
    );

  const [AddManufacturer, { loading: AddStockManufacturerLoading }] =
    useMutation<AddStockManufacturerResult, AddStockManufacturerVar>(
      AddStockManufacturer,
      {
        onError: (e) => {
          setMessage({
            flag: true,
            message: e.message,
            operation: Operation.NONE,
          });
        },
      }
    );
  const [UpdateManufacturer, { loading: UpdateStockManufacturerLoading }] =
    useMutation<UpdateStockManufacturerResult, UpdateStockManufacturerVar>(
      UpdateStockManufacturer,
      {
        onError: (e) => {
          setMessage({
            flag: true,
            message: e.message,
            operation: Operation.NONE,
          });
        },
      }
    );

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<formDataType>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };
  const handleClear = () => {
    const inputElement = document.getElementsByName(
      "groupName"
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();
    setFormData({
      groupName: "",
    });
  };

  const handleSubmit = async () => {
    if (customer_id) {
      if (operation === Operation.UPDATE) {
        const customerUpdated = UpdateManufacturer({
          variables: {
          
            user_details,
            manufacturer_id: state.manufacturerId,
            manufacturer: formData.groupName,
          },
          refetchQueries: [
            {
              query: GetStockManufacturers,
              variables: {
                after: null,
                customer_id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsStckManufacturerOrderField.MANUFACTURER,
                },
              
                name: EMPTY_STRING,
              },
            },
          ],
        });
        const { data } = await customerUpdated;

        if (data && data.UpdateStockManufacturer) {
          setMessage({
            flag: true,
            message: "Manufacturer details updated successfully",
            operation: Operation.CREATE,
          });
          dispatch({
            type: payloadTypes.SET_MANUFACTURER_ID,
            payload: {
              manufacturerId: 0,
            },
          });
        }
      } else {
        const empAdded = AddManufacturer({
          variables: {
          
            user_details,
            customer_id,
            manufacturer: formData.groupName,
          },
          refetchQueries: [
            {
              query: GetStockManufacturers,
              variables: {
                after: null,
                customer_id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsStckManufacturerOrderField.MANUFACTURER,
                },
              
                name: EMPTY_STRING,
              },
            },
          ],
        });
        const { data } = await empAdded;

        if (data && data.AddStockManufacturer) {
          setMessage({
            flag: true,
            message: "Manufacturer added successfully",
            operation: Operation.CREATE,
          });
        }
      }
    }
  };

  const hanldeClear = () => {
    setFormData({
      groupName: "",
    });
  };
  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      hanldeClear();
    }
    setMessage(emptyMessage);
  };

  useEffect(() => {
    if (state.manufacturerId && operation === Operation.UPDATE) {
      GetManufacturer({
        variables: {
          id: state.manufacturerId,
        
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setFormData({
            groupName: data.node.manufacturer,
          });
        }
      });
    }
  }, [state.manufacturerId, GetManufacturer, operation]);

  return (
    <>
      {type === PageFor.GENERAL && (
        <>
          <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />{" "}
        </>
      )}
      <div className="master-data--modal--title">
        <Title>Manufacturer</Title>
        {type === PageFor.MODAL && (
          <img src={Close} alt="" onClick={() => setModal?.(false)} />
        )}
      </div>

      <Formik
        initialValues={formData}
        validationSchema={categoryValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <Form
              className={`master-data${
                type === PageFor.MODAL ? "--modal" : ""
              }`}
            >
              <div
                className={`master-data__datablock${
                  type === PageFor.MODAL ? "--modal" : ""
                }`}
              >
                <div className="master-data__datablock--left">
                  <Add
                    type={PageFor.GENERAL}
                    formData={formData}
                    handleValueChange={handleValueChange}
                    setOperation={setOperation}
                    meta={meta}
                    operation={operation}
                  />
                </div>
                <div className="master-data__datablock--right">
                  <List
                    type={PageFor.GENERAL}
                    setOperation={setOperation}
                    handleClear={handleClear}
                  />
                </div>
              </div>
              <Button mode="save" type="submit" />
              <Button mode="clear" type="button" onClick={handleClear} />
              {type === PageFor.GENERAL ? (
                <Button
                  mode="back"
                  type="button"
                  onClick={() => navigate(-1)}
                />
              ) : (
                <Button
                  mode="cancel"
                  type="button"
                  onClick={() => setModal?.(false)}
                />
              )}
            </Form>
          );
        }}
      </Formik>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal
        flag={
          GetManufacturerByNodeIdLoading ||
          AddStockManufacturerLoading ||
          UpdateStockManufacturerLoading
        }
      />
    </>
  );
};

export default Manufacturer;
